import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvService {

  public IdleTimeInMinutes = -1;

  public Keys = {
    "production":false,
    "portalName":"",
    "localStorageEncryptionEnabled":false,
    "systemId":425,
    "useGlobalLanding": false,
    "buildFolderName": "Clinics",
    "imageLogo": './assets/media/logos/eska-header-logo.png',
    "changePasswordEnabled": true,
    "cloudManagerEnabled": false,
    "referralCode": 'LRP',
    "buildNo": '',
  };

  public Environment = {
    "carenetApiUrl": "",
    "reportingApiUrl": "",
    "globalLandingUrl": '',
    "websiteLoginURL": '',
  };

  public ErrorsHandler = {
    "EnableErrorsHandler": false,
    "ShowErrorAsNotification": false
  };

  public ChangePasswordMessages = [];

  constructor() {

  }
}
